import React from 'react';
import ReactServer from 'react-dom/server';
import Helmet from 'react-helmet';

import Link from 'gatsby-link';
import _ from 'lodash';

// Components
import Card from '../../components/Card';
import Header from '../../components/Header';
import Leaderboard from '../../components/Leaderboard';
import { MoleculeIcon } from '../../components/AnimatedIcons';

import { getContinuousVerb, getDeterminer } from '../../utils';

// Styles
import {
  StyledWrapper,
  ContentWrapper,
  SideWrapper,
  MarkdownWrapper,
  HeaderSection,
  BackLinkWrap,
  SpiceWrapper
} from './NutrientTemplateStyles';

export default function Template({
  pathContext,
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data; // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark;
  const { altname, path, name, tags } = frontmatter;
  const { topFoods } = pathContext;

  // placeholders in markdown for dynamic components
  // const compiledSources = ReactServer.renderToStaticMarkup(<Leaderboard key={'1'} title={`Top Sources of ${name}`} items={topFoods} />);

  const enhancedHTML = html
    .replace(/\$NAME/g, name);
    // .replace('$SOURCES', compiledSources);

  return (
    <StyledWrapper>
      <Helmet
        title={`What is ${name}?`}
        meta={[
          { name: 'description', content: `What is ${name}?` },
          { name: 'keywords', content: `${name},${tags},nutrient,health` },
        ]} />
      <Header backLink={true} />
      <SpiceWrapper>
        <MoleculeIcon
          ringColor='black'
          centerColor='black'
          electronColor='black'
          width={50}
          height={50} />
      </SpiceWrapper>
      <ContentWrapper>
        <MarkdownWrapper className='content--markdown' dangerouslySetInnerHTML={{ __html: enhancedHTML }}></MarkdownWrapper>
        <SideWrapper>
          {topFoods && (
            <Leaderboard
              collapseAfter={25}
              key={'1'}
              title={`Top Sources of ${name} (per serving)`}
              description={`Here are some foods rich in ${name}. (1μg is 0.001mg)`}
              items={topFoods} />
          )}
        </SideWrapper>
      </ContentWrapper>
    </StyledWrapper>
  );
};

export const pageQuery = graphql`
  query NutrientItems($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        name
        altname
        tags
        nutrient_id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/NutrientTemplate/NutrientTemplate.js